import { get, post } from '../axios'

// getBaseInfo
export function commodity_baseInfo_get(map, option) {
  return get(
    `${process.env.VUE_APP_COMMODITY}/commodity/baseInfo`,
    map,
    option
  ).then(response => response)
}

// 查询积分抵扣商品
export function commodity_deduct_get(map, option) {
  return get(
    `${process.env.VUE_APP_COMMODITY}/commodity/deduct`,
    map,
    option
  ).then(response => response)
}

// queryCommodityDetail
export function commodity_detail_get(map, option) {
  return get(
    `${process.env.VUE_APP_COMMODITY}/commodity/detail`,
    map,
    option
  ).then(response => response)
}

// queryPdpBanner
export function commodity_detail_banner_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMODITY}/commodity/detail/banner`,
    map,
    option
  ).then(response => response)
}

// 红人视频
export function commodity_hot_media_get(map, option) {
  return get(
    `${process.env.VUE_APP_COMMODITY}/commodity/hot/media`,
    map,
    option
  ).then(response => response)
}

// 大码联动
export function commodity_link_get(map, option) {
  return get(
    `${process.env.VUE_APP_COMMODITY}/commodity/link`,
    map,
    option
  ).then(response => response)
}

// 查询模特信息
export function commodity_model_info_get(map, option) {
  return get(
    `${process.env.VUE_APP_COMMODITY}/commodity/model/info`,
    map,
    option
  ).then(response => response)
}

// 查询模特信息
export function commodity_model_info_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMODITY}/commodity/model/info`,
    map,
    option
  ).then(response => response)
}

// 查询模特信息
export function commodity_model_infos_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMODITY}/commodity/model/infos`,
    map,
    option
  ).then(response => response)
}

// calPonitsGet
export function commodity_point_get(map, option) {
  return get(
    `${process.env.VUE_APP_COMMODITY}/commodity/point`,
    map,
    option
  ).then(response => response)
}

// calPonits
export function commodity_point_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMODITY}/commodity/point`,
    map,
    option
  ).then(response => response)
}

// 设置缓存
export function commodity_postCache_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMODITY}/commodity/postCache`,
    map,
    option
  ).then(response => response)
}

// 实时查价格库存
export function commodity_priceInventory_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMODITY}/commodity/priceInventory`,
    map,
    option
  ).then(response => response)
}

// pdp倒计时
export function commodity_queryActivityCountdown_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMODITY}/commodity/queryActivityCountdown`,
    map,
    option
  ).then(response => response)
}

// 查询skc氛围文案
export function commodity_queryAmbienceDesc_get(map, option) {
  return get(
    `${process.env.VUE_APP_COMMODITY}/commodity/queryAmbienceDesc`,
    map,
    option
  ).then(response => response)
}

// 秒杀倒计时
export function commodity_queryPriceChange_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMODITY}/commodity/queryPriceChange`,
    map,
    option
  ).then(response => response)
}

// pdp推荐商品
export function commodity_recommend_get(map, option) {
  return get(
    `${process.env.VUE_APP_COMMODITY}/commodity/recommend`,
    map,
    option
  ).then(response => response)
}

// pdp推荐商品
export function commodity_recommend_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMODITY}/commodity/recommend`,
    map,
    option
  ).then(response => response)
}

// pdp推荐商品
export function commodity_recommend_deprecated_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMODITY}/commodity/recommend/deprecated`,
    map,
    option
  ).then(response => response)
}

// querySelfBuildCommodityDetail
export function commodity_selfbuild_detail_get(map, option) {
  return get(
    `${process.env.VUE_APP_COMMODITY}/commodity/selfbuild/detail`,
    map,
    option
  ).then(response => response)
}

// 自建站-分体详情
export function commodity_selfbuild_split_info_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMODITY}/commodity/selfbuild/split/info`,
    map,
    option
  ).then(response => response)
}

// 设置缓存
export function commodity_setCache_get(map, option) {
  return get(
    `${process.env.VUE_APP_COMMODITY}/commodity/setCache`,
    map,
    option
  ).then(response => response)
}

// shipping&return
export function commodity_shippingReturn_get(map, option) {
  return get(
    `${process.env.VUE_APP_COMMODITY}/commodity/shippingReturn`,
    map,
    option
  ).then(response => response)
}

// shipping&return
export function commodity_shippingReturn_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMODITY}/commodity/shippingReturn`,
    map,
    option
  ).then(response => response)
}

// 分体详情Get接口
export function commodity_split_info_get(map, option) {
  return get(
    `${process.env.VUE_APP_COMMODITY}/commodity/split/info`,
    map,
    option
  ).then(response => response)
}

// 分体详情
export function commodity_split_info_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMODITY}/commodity/split/info`,
    map,
    option
  ).then(response => response)
}

// 分体详情
export function commodity_split_info_deprecated_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMODITY}/commodity/split/info/deprecated`,
    map,
    option
  ).then(response => response)
}

// buy it with(B方案)
export function commodity_split_page_get(map, option) {
  return get(
    `${process.env.VUE_APP_COMMODITY}/commodity/split/page`,
    map,
    option
  ).then(response => response)
}

// getSpuInfo
export function commodity_spu_info_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMODITY}/commodity/spu/info`,
    map,
    option
  ).then(response => response)
}

// 实时查价格库存
export function commodity_test_priceInventory_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMODITY}/commodity/test/priceInventory`,
    map,
    option
  ).then(response => response)
}

// trans2SkcCode
export function commodity_trans2SkcCode_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMODITY}/commodity/trans2SkcCode`,
    map,
    option
  ).then(response => response)
}

// queryBacthSkcDetails
export function commodity_selfbuild_batch_detail_get(map, option) {
  return get(
    `${process.env.VUE_APP_COMMODITY}/commodity/selfbuild/batch/detail`,
    map,
    option
  ).then(response => response)
}
